import { useEffect, useRef } from "react";

/**
 * Atajo de teclado "n" → crear registro (tabla, kanban, calendario). Con foco
 * fuera de campos de texto y sin modales abiertos, la tecla "n" llama a
 * `onCreate`. Sin `enabled` (p. ej. sin permiso de crear) no hace nada.
 */
export function useCreateShortcut(onCreate: () => void, enabled = true) {
  // La última función, sin volver a registrar el listener en cada render.
  const createRef = useRef(onCreate);
  createRef.current = onCreate;

  useEffect(() => {
    if (!enabled) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.repeat || e.ctrlKey || e.metaKey || e.altKey) return;
      if (e.key !== "n" && e.key !== "N") return;

      // No interferir cuando el usuario está escribiendo.
      const el = document.activeElement as HTMLElement | null;
      if (
        el &&
        (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || el.isContentEditable)
      ) {
        return;
      }

      // No abrir un segundo formulario sobre un modal/diálogo ya abierto.
      if (document.querySelector('[role="dialog"]')) return;

      e.preventDefault();
      createRef.current();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled]);
}
